import { memo } from 'react'
import { Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { IProductWarrantyClaim } from '@cbgms/api'
import { useStyles } from '../styles/form.style'
import { useFormikContext } from 'formik'

const _CompanyProductDetailsViewSection = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { values: formValues } = useFormikContext<IProductWarrantyClaim>()

  return (
    <Grid item direction='column' sx={{ mt: '0px !important' }}>
      <Grid item sx={{ my: 3 }}>
        <Typography className={classes.sectionHeader}>{t('productWarrantyClaim.company_product_details')}</Typography>
      </Grid>

      <Grid item container spacing={2}>
        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.company_name')}:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{formValues?.FormData.CompanyProductDetails.CompanyName}</Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.customer_number')}:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{formValues?.FormData.CompanyProductDetails.CustomerName}</Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.email')}:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{formValues?.FormData.CompanyProductDetails.EmailAddress}</Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.article_number')}:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{formValues?.FormData.CompanyProductDetails.ArticleNumber}</Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.quantity')}:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{formValues?.FormData.CompanyProductDetails.ProductQuantity}</Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.item_description')}:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{formValues?.FormData.CompanyProductDetails.ItemDescription}</Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

const CompanyProductDetailsViewSection = memo(_CompanyProductDetailsViewSection)
export default CompanyProductDetailsViewSection
